/**
 * @desc 删除
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(id: string | number, options?: any) {
  return updateResponse(
    http(URL + `/ProductSizeSection/delete/${id}`, {
      method: "POST",

      ...options,
    }),
  );
}
